import { render, staticRenderFns } from "./TagViewSelect.vue?vue&type=template&id=1b8a6e03&scoped=true&"
import script from "./TagViewSelect.vue?vue&type=script&lang=ts&"
export * from "./TagViewSelect.vue?vue&type=script&lang=ts&"
import style0 from "./TagViewSelect.vue?vue&type=style&index=0&id=1b8a6e03&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8a6e03",
  null
  
)

export default component.exports